/*
 * Author: @Yixian Li
 */
export const getElementPathInfo = (element: Element, deep?: number) => {
  let ele: Element | null = element;
  const pathInfo = [];
  while (ele && ele.tagName !== 'BODY' && (deep ? pathInfo.length < deep : true)) {
    pathInfo.push({
      tagName: ele.tagName,
      className: ele.className,
    });
    ele = ele.parentElement;
  }
  return pathInfo;
};

const hookFuncbyName = function (
  className: Function,
  methodName: string,
  replaceFunc: Function,
) {
  const originalFuc = className.prototype[methodName];
  className.prototype[methodName] = function (...param: any) {
    return replaceFunc(originalFuc, this, ...param);
  };
};

export const initHookFunc = (
  callback: (param: { type: string; tags: { [key: string]: any } }) => void,
) => {
  hookFuncbyName(
    Node,
    'appendChild',
    (originalFunc: Function, _this: Node, param: Node) => {
      try {
        return originalFunc.call(_this, param);
      } catch (error) {
        callback({
          type: 'appendChild Node Error',
          tags: {
            node: getElementPathInfo(param as Element, 10),
            nodeContent: param?.textContent || '',
            currentNode: {
              content: _this?.textContent || '',
              tagName: (_this as Element)?.tagName,
              className: (_this as Element)?.className,
            },
            message: error.stack ?? error.message,
          },
        });
        return param;
      }
    },
  );
  hookFuncbyName(
    Node,
    'removeChild',
    (originalFunc: Function, _this: Node, param: Node) => {
      try {
        return originalFunc.call(_this, param);
      } catch (error) {
        callback({
          type: 'removeChild Node Error',
          tags: {
            node: getElementPathInfo(param as Element, 10),
            nodeContent: param?.textContent || '',
            currentNode: {
              content: _this?.textContent || '',
              tagName: (_this as Element)?.tagName,
              className: (_this as Element)?.className,
            },
            message: error.stack ?? error.message,
          },
        });
        return param;
      }
    },
  );
  hookFuncbyName(
    Node,
    'insertBefore',
    (originalFunc: Function, _this: Node, newNode: Node, refNode: Node) => {
      try {
        return originalFunc.call(_this, newNode, refNode);
      } catch (error) {
        callback({
          type: 'insertBefore Node Error',
          tags: {
            node: getElementPathInfo(refNode as Element, 10),
            newNode: newNode?.textContent || '',
            currentNode: {
              content: _this?.textContent || '',
              tagName: (_this as Element)?.tagName,
              className: (_this as Element)?.className,
            },
            message: error.stack ?? error.message,
          },
        });
        return newNode;
      }
    },
  );
  hookFuncbyName(
    Element,
    'removeChild',
    (originalFunc: Function, _this: Node, param: Node) => {
      try {
        return originalFunc.call(_this, param);
      } catch (error) {
        callback({
          type: 'removeChild Node Error',
          tags: {
            node: getElementPathInfo(param as Element, 10),
            nodeContent: param?.textContent || '',
            currentNode: {
              content: _this?.textContent || '',
              tagName: (_this as Element)?.tagName,
              className: (_this as Element)?.className,
            },
            message: error.stack ?? error.message,
          },
        });
        return param;
      }
    },
  );
  hookFuncbyName(
    Element,
    'insertBefore',
    (originalFunc: Function, _this: Node, newNode: Node, refNode: Node) => {
      try {
        return originalFunc.call(_this, newNode, refNode);
      } catch (error) {
        callback({
          type: 'insertBefore Node Error',
          tags: {
            node: getElementPathInfo(refNode as Element, 10),
            newNode: newNode?.textContent || '',
            currentNode: {
              content: _this?.textContent || '',
              tagName: (_this as Element)?.tagName,
              className: (_this as Element)?.className,
            },
            message: error.stack ?? error.message,
          },
        });
        return newNode;
      }
    },
  );
  hookFuncbyName(
    Element,
    'appendChild',
    (originalFunc: Function, _this: Node, param: Node) => {
      try {
        return originalFunc.call(_this, param);
      } catch (error) {
        callback({
          type: 'appendChild Element Error',
          tags: {
            node: getElementPathInfo(param as Element, 10),
            newNode: param?.textContent || '',
            currentNode: {
              content: _this?.textContent || '',
              tagName: (_this as Element)?.tagName,
              className: (_this as Element)?.className,
            },
            message: error.stack ?? error.message,
          },
        });
        return param;
      }
    },
  )
};
